<template>
  <div class="strong-msg-wrapper" v-if="content">
    <p class="desc" v-text="content"></p>
  </div>
</template>

<script>
export default {
  name: 'StrongTips',
  props: {
    content: String,
  },
}
</script>

<style lang="scss" scoped >
.strong-msg-wrapper {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 10;
  display: table;
  margin: auto;
  padding: 4px 50px;
  width: 100%;
  min-height: 48px;
  line-height: 18px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  background: #1BB17C;
}
.desc {
  display: table-cell;
  vertical-align: middle;
}
@media screen and (max-width: 768px){
  .strong-msg-wrapper {
    position: unset;
    margin: 0;
    width: 100%;
  }
  .strong-msg-wrapper {
    padding: rem(16) rem(100);
    line-height: rem(34);
    font-size: rem(28);
  }
}
</style>